export default __webpack_public_path__ + "static/media/id.be6fb173.png";